import styled, { css } from 'styled-components';

export const Wrapper = styled.div`
  ${({ theme, isProPlan, $renderingSkeleton }) => css`
    background: ${theme.v2.colors.neutral.highPure};
    border-radius: 16px;
    color: ${theme.v2.colors.neutral.lowDark};
    display: flex;
    flex-direction: column;
    font-family: ${theme.v2.font.family.primary};
    gap: 40px;
    padding: 0 24px 50px 24px;
    width: 100%;

    ${isProPlan && css`
      margin-top: -16px;
      border-radius: 0 0 16px 16px;
    `}

    ${$renderingSkeleton && css`
      padding-top: 24px;
    `}

    @media (max-width: ${theme.v2.breakpoints.sm}) {
      border-radius: 0;
      gap: 24px;

      ${!$renderingSkeleton && css`
        padding: 0 0 50px 0;
      `}
    }
  `}
`;

export const EmptyState = styled.div`
  align-items: center;
  display: flex;
  flex-direction: column;
  gap: 16px;
  height: 360px;
  justify-content: center;
  padding: 24px;
`;

export const FormatList = styled.div`
  ${({ theme }) => css`
    background: ${theme.v2.colors.neutral.high};
    display: flex;
    flex-wrap: wrap;
    gap: 24px;
    margin-bottom: 16px;

    @media (max-width: ${theme.v2.breakpoints.sm}) {
      gap: 0;
      margin-bottom: 0;
    }
  `}
`;

export const TemplateCards = styled.div`
  ${({ theme }) => css`
    box-sizing: border-box;
    display: flex;
    gap: 16px;
    margin: -24px;
    max-width: calc(100% + 48px);
    overflow-x: auto;
    padding: 24px;
    scroll-behavior: smooth;
    width: calc(100% + 48px);

    &::-webkit-scrollbar {
      display: none;
    }

    @media (max-width: ${theme.v2.breakpoints.sm}) {
      padding-left: 20px;
      max-width: 100%;
      width: 100%;
      margin: 0;
      padding: 16px;
    }
  `}
`;

export const FormatListSkeleton = styled.div`
  ${({ theme }) => css`
    background: ${theme.v2.colors.neutral.high};
    display: flex;
    flex-wrap: wrap;
    gap: 16px;
    overflow: hidden;
  `}
`;

export const TemplateCardsSkeleton = styled.div`
  ${({ theme }) => css`
    display: flex;
    gap: 16px;
    margin-bottom: 16px;

    @media (max-width: ${theme.v2.breakpoints.sm}) {
      margin-bottom: 0;
    }
  `};
`;

export const SkeletonContent = styled.div`
  ${({ theme }) => css`
    display: flex;
    flex-direction: column;
    gap: 20px;

    @media (max-width: ${theme.v2.breakpoints.sm}) {
      padding: 0 16px;
    }
  `};
`;

export const TemplateCard = styled.div`
  ${({ theme, format }) => {
    const getFormatStyles = (format) => {
      switch (format) {
        case 'instagram_post':
        case 'global_facebook_post':
        case 'capa_tiktok':
        case 'global_whatsapp_post':
          return {
            borderRadius: '16px',
            height: '200px',
            width: '200px',
            mobileHeight: '137px',
            mobileWidth: '137px',
          };
        case 'insta_stories':
        case 'global_facebook_vertical':
          return {
            borderRadius: '16px',
            height: '314px',
            width: '200px',
            mobileHeight: '190.85px',
            mobileWidth: '121.56px',
          };
        case 'capa_facebook':
        case 'capa_youtube':
          return {
            borderRadius: '16px',
            height: '144px',
            width: '306.5px',
            mobileHeight: '89.49px',
            mobileWidth: '188.29px',
          };
        case 'global_youtube_icone':
          return {
            borderRadius: '150px',
            height: '200px',
            width: '200px',
            mobileHeight: '92.46px',
            mobileWidth: '92.46px',
          };
        case 'catalogo_virtual':
        case 'global_ebook_A4_Vertical':
        case 'mini_sites':
        case 'promo_link':
          return {
            borderRadius: '16px',
            height: '258px',
            width: '200px',
            mobileHeight: '155.26px',
            mobileWidth: '98.89px',
          };
        default:
          return {
            borderRadius: '16px',
            height: '200px',
            width: '200px',
            mobileHeight: '137px',
            mobileWidth: '137px',
          };
      }
    };

    const { borderRadius, height, width } = getFormatStyles(format);

    return css`
      background: ${theme.v2.colors.neutral.high};
      border-radius: ${borderRadius};
      cursor: pointer;
      height: ${height};
      min-height: ${height};
      min-width: ${width};
      overflow: hidden;
      position: relative;
      transition: 0.3s ease-in-out;
      width: ${width};
      flex: 0 0 auto;

      &:hover {
        transform: scale(1.1);
        box-shadow: ${theme.v2.shadows.dark};
      }
    `;
  }}
`;

export const TemplateImage = styled.img`
  ${({ theme }) => css`
    background: ${theme.v2.colors.neutral.high};
    height: 100%;
    object-fit: cover;
    width: 100%;
  `}
`;

export const FormatListHeader = styled.div`
  ${({ theme }) => css`
    align-items: center;
    display: flex;
    justify-content: space-between;
    width: 100%;

    button {
      /* padding: 4px 8px; */
    }

    @media (max-width: ${theme.v2.breakpoints.sm}) {
      padding: 0 20px;
    }
  `}
`;

export const FormatTitle = styled.h4`
  ${({ theme }) => css`
    color: ${theme.v2.colors.neutral.lowDark};
    font-family: ${theme.v2.font.family.primary};
    font-size: ${theme.v2.font.sizes.sm};
    font-weight: ${theme.v2.font.weights.medium};
    margin: 0;
    width: 100%;

    @media (max-width: ${theme.v2.breakpoints.sm}) {
      font-size: ${theme.v2.font.sizes.xs};
    }
  `}
`;

export const ButtonWrapper = styled.div`
  ${({ theme }) => css`
    display: flex;
    justify-content: center;
    margin-top: 12px;
    width: 100%;

    @media (max-width: ${theme.v2.breakpoints.sm}) {
      padding: 0 20px;
    }
  `}
`;

export const InfinityScrollWrapper = styled.div`
  ${({ theme }) => css`
    display: flex;
    justify-content: center;
    margin-top: 12px;
    width: 100%;

    @media (max-width: ${theme.v2.breakpoints.sm}) {
      padding: 0 20px;
    }
  `}
`;
